import { Box, Drawer, List } from '@mui/material';

import { SIZES } from '../../../../assets/constants/constants.ts';
import { useMenuItems } from '../menu-items.tsx';
// import { flattenMenuLinks } from '../menu-items.tsx';
import { NavbarButtons } from '../navbar-buttons.tsx';

import NavItem from './_components/NavItem.tsx';

interface SideBarProps {
  onSideBarClose?(...args: unknown[]): unknown;
  isSideBarOpen?: boolean;
  data?: any;
}

const SideBar = ({ onSideBarClose = () => {}, isSideBarOpen = false }: SideBarProps) => {
  const items = useMenuItems();
  // const origItems = useMenuItems();
  // const items = flattenMenuLinks(origItems);

  return (
    <Drawer
      anchor="left"
      variant="temporary"
      onClose={onSideBarClose}
      open={isSideBarOpen}
      slotProps={{
        paper: {
          sx: {
            width: '100%',
            top: SIZES.topBar.height.small,
            height: `calc(100vh - ${SIZES.topBar.height.small}px)`,
          },
        },
        backdrop: {
          invisible: true,
        },
      }}
      sx={(theme) => ({
        [theme.breakpoints.up(SIZES.navigationChange)]: {
          display: 'none',
        },
      })}
    >
      <Box
        sx={(theme) => ({
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          paddingTop: theme.spacing(3),
          overflowY: 'auto',
        })}
      >
        <List component="nav">
          {items.map((item) => (
            <NavItem
              key={item.title}
              menuItem={item}
              onClick={() => {
                onSideBarClose();
              }}
            />
          ))}
        </List>

        <Box
          sx={(theme) => ({
            display: 'flex',
            flexDirection: 'column',
            padding: theme.spacing(3, 8, 8),
            '& > a': {
              marginTop: theme.spacing(2),
            },
            [theme.breakpoints.down(450)]: {
              padding: theme.spacing(3, 6, 8),
              '& > button, a': {
                paddingLeft: theme.spacing(1.5),
                paddingRight: theme.spacing(1.5),
              },
            },
          })}
        >
          <NavbarButtons
            className="flex flex-col gap-3"
            onNavigate={() => {
              onSideBarClose();
            }}
          />
        </Box>
      </Box>
    </Drawer>
  );
};

export default SideBar;
